import { Box, Button, Divider, IconButton, Tooltip, Typography } from "@mui/material";
import { useStyles } from "../../styles";
import { useTranslation } from "react-i18next";
import { CustomPaper } from "../../../../../../../../../../components/CustomPaper";
import { useParams } from "react-router-dom";
import { useState } from "react";
import { format } from "date-fns";
import { es } from "date-fns/locale";
import { icons } from "../../../../../../../../../../utils/icons";
import { useEvidences } from "../../../../../../../../../../hooks/evidences/useEvidences";
import EvidenceDetail from "../../../../../../../../../actionPlans/pages/form/components/evidenceDetail";
import { SnackSimple } from "../../../../../../../../../../components";
import { Types } from "../../../../../../../../../../utils/enums/types";
import { VIEW_TYPES } from "../../../../types/ViewTypes";
import StarIcon from '@mui/icons-material/Star';
import { getLocalStorage, LocaleNameType } from "../../../../../../../../../../utils/crud/crypt";
import { Status } from "../../../../../../../../../../utils/enums";
import { Questionnary } from "../Questionnary";
import { ActionDrawer } from "../../../../../../../../../../components/ActionDrawer";
import { useEvidenceDownload } from "../../../../../../../../../calendar/pages/detail/hooks";
import { Constants } from "../../../../../../../../../../utils/constants";
import { AnswerTypeHistory } from "../../../../enums/answerType";

export const SolutionResponse = ({ items, onAttend, reload, left, disabled }) => {
  const styles = useStyles();
  const { t } = useTranslation();
  const { id: reportFolioId } = useParams();
  const [isModalOpen, setModalOpen] = useState(false);
  const lastQuote = items?.filter((item) => item.type === AnswerTypeHistory.SOLUTION).at(-1);
  const reasonOfRejectionQuote = null
  const reasonOfApproveQuote = null
  const state: { isManagerOfDeparment: boolean, role: number } = getLocalStorage(LocaleNameType.STATE);
  const isManagerOfDepartment = state?.isManagerOfDeparment;
  const isAdmin = state?.role === 1;
  const { evidences, existEvidences } = useEvidences({
    evidencesResponse: lastQuote.type == AnswerTypeHistory.SOLUTION ? lastQuote?.evidencesAnswer : lastQuote?.evidencesQuote ? lastQuote?.evidencesQuote : lastQuote?.evidencesAnswer,
    manualValue: false,
  });
  const { disable: isDownloading, /* openSnackbar, handleCloseSnackbar, */ downloadEvidences, } = useEvidenceDownload('evidencias', lastQuote.type == AnswerTypeHistory.SOLUTION ? lastQuote?.evidencesAnswer : lastQuote?.evidencesQuote ? lastQuote?.evidencesQuote : lastQuote?.evidencesAnswer);
  const [downloadSnack, setDownloadSnack] = useState({
    open: false,
    message: ""
  });
  const isApproved = lastQuote?.statusIdAnswer === 19
  const isQuestionarieExpired = lastQuote?.assingQuestionnaire?.statusId === Status.EXPIRED
  const isRejected = (!isAdmin && !isManagerOfDepartment)
    && lastQuote?.statusIdAnswer === 13
    && lastQuote.commentApprovalAnswer == null;

  const isSolutionSend = lastQuote?.answerSubmitted && lastQuote?.statusIdAnswer === Status.RESPONDED

  const rating = left?.rating
  const commentSolution = lastQuote?.commentApprovalAnswer
  const provider = lastQuote?.usersAssings?.[0]
    ? `${lastQuote.usersAssings[0].firstName} ${lastQuote.usersAssings[0].lastName}`
    : t("reportFolio.detail.general.noAssignedUser");

  /* const formattedDate = lastQuote?.dateRequestQuote
    ? format(new Date(lastQuote.dateRequestQuote), "dd/MM/yyyy HH:mm", { locale: es })
    : null; */

  const formattedDate = lastQuote.type !== AnswerTypeHistory.SOLUTION ?
    lastQuote?.dateUploadQuote
      ? format(new Date(lastQuote.dateUploadQuote), Constants.dateFormatGeneral3, { locale: es })
      : t("reportFolio.detail.general.noDateAvailable")
    : lastQuote?.dateUploadSolution ? format(new Date(lastQuote.dateUploadSolution), Constants.dateFormatGeneral3, { locale: es })
      : t("reportFolio.detail.general.noDateAvailable")
    ;

  const formatedDateSolution = lastQuote?.dateRequestCreateFolio
    ? format(new Date(lastQuote.dateRequestCreateFolio), Constants.dateFormatGeneral3, { locale: es })
    : null

  const formatDateRequest = lastQuote?.dateRequestManagement
    ? format(new Date(lastQuote.dateRequestManagement), Constants.dateFormatGeneral3, { locale: es })
    : t("reportFolio.detail.general.noDateAvailable");

  const descriptionAnswer = lastQuote?.descriptionAnswer

  const handleAttend = () => {
    onAttend();
    setModalOpen(true);
  };

  const handleDownloadQuoteZip = async () => {
    setDownloadSnack({
      open: true,
      message: "Descargando evidencias..."
    });
    try {
      await downloadEvidences(lastQuote?.evidencesQuote, "evidences.zip");
    } catch (error) {
      console.error("Error downloading evidences:", error);
      setDownloadSnack({
        open: true,
        message: t("reportFolio.detail.general.oppsError")
      });
    } finally {
      setTimeout(() => {
        setDownloadSnack({
          open: false,
          message: ""
        });
      }, 3000);
    }
  };

  const handleDownloadSolutionZip = async () => {
    setDownloadSnack({
      open: true,
      message: "Descargando evidencias..."
    });
    try {
      await downloadEvidences(lastQuote?.evidencesAnswer, "evidences.zip");
    } catch (error) {
      console.error("Error downloading evidences:", error);
      setDownloadSnack({
        open: true,
        message: t("reportFolio.detail.general.oppsError")
      });
    } finally {
      setTimeout(() => {
        setDownloadSnack({
          open: false,
          message: ""
        });
      }, 3000);
    }
  };


  return (
    <>
      <CustomPaper sx={styles.userContainer} elevation={3}>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Box>
            <Box >
              {reasonOfRejectionQuote ? (
                <Box display="flex" alignItems="center">
                  <Typography sx={styles.title(3)}>
                    {icons("cancel")}
                  </Typography>
                  <Typography style={{ marginLeft: '8px' }} sx={styles.title(3)}>
                    {t("reportFolio.detail.general.quotationTitleProviderSendCancel")}
                  </Typography>
                </Box>
              ) : reasonOfApproveQuote ? (
                <Box display="flex" alignItems="center">
                  <Typography sx={styles.title(4)}>
                    {icons("check")}
                  </Typography>
                  <Typography style={{ marginLeft: '8px' }} sx={styles.title(4)}>
                    {t("reportFolio.detail.general.quotationTitleProviderSendApprove")}
                  </Typography>
                </Box>
              ) : isSolutionSend ? (
                <Box display="flex" alignItems="center">
                  <Typography sx={styles.title(2)}>
                    {icons("info")}
                  </Typography>
                  <Typography style={{ marginLeft: '8px' }} sx={styles.title(2)}>
                    {t("reportFolio.detail.general.solutionProviderSend")}
                  </Typography>
                </Box>
              ) : isApproved ? (
                <Box display="flex" alignItems="center">
                  <Typography sx={styles.title(4)}>
                    {icons("check")}
                  </Typography>
                  <Typography style={{ marginLeft: '8px' }} sx={styles.title(4)}>
                    {t("reportFolio.detail.general.solutionTitleProviderSendApprove")}
                  </Typography>
                </Box>
              ) : isRejected ? (
                <Box display="flex" alignItems="center">
                  <Typography sx={styles.title(3)}>
                    {icons("cancel")}
                  </Typography>
                  <Typography style={{ marginLeft: '8px' }} sx={styles.title(3)}>
                    {t("reportFolio.detail.general.solutionTitleProviderSendCancel")}
                  </Typography>
                </Box>
              ) : (<Box>
                <Typography sx={styles.title(2)}>
                  {t("reportFolio.detail.general.solutionTitleProvider")}
                </Typography>
                <Typography variant="body2">
                  {t("reportFolio.detail.general.providerAssigned", { provider })}
                </Typography>
              </Box>)
              }
            </Box>

            {reasonOfRejectionQuote ? (
              <Typography variant="body2">
                {t("reportFolio.detail.general.providerAssignedAndDateAndReject", {
                  Proveedor: provider,
                  Date: formattedDate,
                  Rechazada: formatDateRequest,
                })}
              </Typography>
            ) : reasonOfApproveQuote ? (
              <Typography variant="body2">
                {t("reportFolio.detail.general.providerAssignedAndDateAndApprove", {
                  Proveedor: provider,
                  Date: formattedDate,
                  Rechazada: formatDateRequest,
                })}
              </Typography>
            ) : isSolutionSend ? (
              <Typography variant="body2">
                {t("reportFolio.detail.general.providerAssignedAndDate", {
                  Proveedor: provider,
                  Date: formatDateRequest,
                })}
              </Typography>
            ) : isApproved ? (
              <Typography variant="body2">
                {t("reportFolio.detail.general.providerAssignedAndDateAndApprove", {
                  Proveedor: provider,
                  Date: formattedDate,
                  Rechazada: formatDateRequest,
                })}
              </Typography>
            ) : isRejected && formattedDate ? ( // Validación extra para `formattedDate`
              <Typography variant="body2">
                {t("reportFolio.detail.general.providerAssignedAndDateAndReject", {
                  Proveedor: provider,
                  Date: formattedDate,
                  Rechazada: formatDateRequest,
                })}
              </Typography>
            ) : isRejected && formatedDateSolution ? (
              <Typography variant="body2">
                {t("reportFolio.detail.general.providerAssignedAndDateAndReject", {
                  Proveedor: provider,
                  Date: formatedDateSolution,
                  Rechazada: formatDateRequest,
                })}
              </Typography>
            ) : null}

            {commentSolution ? (
              <Typography
                sx={{
                  '&.MuiTypography-root':
                    { wordBreak: "break-word", overflowWrap: "break-word", whiteSpace: "normal", }
                }}
              >
                {commentSolution}
              </Typography>
            ) : <></>}

          </Box>

          {reasonOfRejectionQuote || reasonOfApproveQuote || isSolutionSend || isApproved || isRejected ? (
            <>
            </>
          ) :
            <Box display="flex" gap={2}>
              <Button variant="contained" onClick={() => {
                onAttend(VIEW_TYPES.SEND_SOLUTION)
                reload();
              }} disabled={isQuestionarieExpired || disabled}>
                {t("reportFolio.detail.general.AttendquotationTitle")}
              </Button>
            </Box>
          }
        </Box >
        {
          reasonOfRejectionQuote ? (
            <Typography variant="body1"
              sx={{
                '&.MuiTypography-root':
                  { wordBreak: "break-word", overflowWrap: "break-word", whiteSpace: "normal", }
              }}
            >
              {reasonOfRejectionQuote}
            </Typography >
          ) : reasonOfApproveQuote ? (
            <Typography variant="body1"
              sx={{
                '&.MuiTypography-root':
                  { wordBreak: "break-word", overflowWrap: "break-word", whiteSpace: "normal", }
              }}
            >
              {reasonOfApproveQuote}
            </Typography>
          ) : isSolutionSend ? (
            <Box /* display="flex" alignItems="center" justifyContent="space-between" */>
              <Typography variant="body1">
                {t("reportFolio.detail.general.solutionSendInfo")}
              </Typography>
              {descriptionAnswer ? (
                <Typography
                  sx={{
                    '&.MuiTypography-root':
                      { wordBreak: "break-word", overflowWrap: "break-word", whiteSpace: "normal", }
                  }}
                >
                  {descriptionAnswer}
                </Typography>
              ) : <></>}
              <Box display="flex" alignItems="center" justifyContent={'end'} gap={2}>
                <ActionDrawer
                  title="EVIDENCIAS"
                  body={<>
                    <Box sx={styles.mainContainer}>
                      <Box sx={styles.bodyContainer}>
                        <EvidenceDetail
                          existEvidences={existEvidences}
                          evidences={{
                            image: evidences?.images,
                            comment: evidences?.comments,
                            documents: evidences?.documents,
                            video: evidences?.video,
                            sign: evidences?.sign
                          }}
                        />
                      </Box>
                      <Box>
                        <Button variant='text_primary_small' onClick={downloadEvidences} disabled={isDownloading}>{t('schedule.buttons.downloadEvidence')}</Button>
                      </Box>
                    </Box>
                  </>}
                >
                  {
                    ({ openDrawer }) =>
                      <Tooltip title={t("ToolTips.seeEvidences")}>
                        <IconButton
                          onClick={() => { openDrawer() }}
                          sx={styles.clip}
                          disabled={!existEvidences}
                        >
                          {icons("clip")}
                        </IconButton>
                      </Tooltip>
                  }
                </ActionDrawer>
                {existEvidences &&
                  <Button variant="outlined" color="primary" onClick={handleDownloadSolutionZip}>
                    {t("reportFolio.detail.general.solutionDownload")}
                    <Box ml={1} mt={1}>{icons("download")}</Box>
                  </Button>
                }
              </Box>
            </Box>
          ) : (
            <></>
          )}
        {
          reasonOfRejectionQuote || reasonOfApproveQuote ? (
            <Box display="flex" justifyContent="end" gap={3} alignContent={"center"}>
              <ActionDrawer
                title="EVIDENCIAS"
                body={<>
                  <Box sx={styles.mainContainer}>
                    <Box sx={styles.bodyContainer}>
                      <EvidenceDetail
                        existEvidences={existEvidences}
                        evidences={{
                          image: evidences?.images,
                          comment: evidences?.comments,
                          documents: evidences?.documents,
                          video: evidences?.video,
                          sign: evidences?.sign
                        }}
                      />
                    </Box>
                    <Box>
                      <Button variant='text_primary_small' onClick={downloadEvidences} disabled={isDownloading}>{t('schedule.buttons.downloadEvidence')}</Button>
                    </Box>
                  </Box>
                </>}
              >
                {
                  ({ openDrawer }) =>
                    <Tooltip title={t("ToolTips.seeEvidences")}>
                      <IconButton
                        onClick={() => { openDrawer() }}
                        sx={styles.clip}
                        disabled={!existEvidences}
                      >
                        {icons("clip")}
                      </IconButton>
                    </Tooltip>
                }
              </ActionDrawer>

              <Button variant="outlined" color="primary">
                {t("reportFolio.detail.general.seeDetailQuote")}
              </Button>
              <Button variant="outlined" color="primary" onClick={handleDownloadQuoteZip}>
                {t("reportFolio.detail.general.dowloadQuote")}
                <Box ml={1} mt={1}>{icons("download")}</Box>
              </Button>
            </Box>
          ) : isApproved ? (
            <Box display="flex" justifyContent="space-between" mt={2}>
              <Box display="flex" flexDirection="column">
                {rating?.rating && (
                  <>
                    <Typography variant="body1" color="textSecondary">
                      {rating.ratingQuestion}
                    </Typography>

                    <Box display="flex">
                      {[1, 2, 3, 4, 5].map((star) => (
                        <Typography
                          key={star}
                          component="span"
                          sx={{
                            color: star <= rating.rating ? '#FFD700' : '#E0E0E0',
                            fontSize: '24px'
                          }}
                        >
                          <StarIcon />
                        </Typography>
                      ))}
                    </Box>

                    {rating.ratingComment && (
                      <Typography
                        variant="body2"
                        sx={{ '&.MuiTypography-root': { wordBreak: "break-word", overflowWrap: "break-word", whiteSpace: "normal", }, }}
                      >
                        {rating.ratingComment}
                      </Typography>
                    )}
                  </>
                )}
              </Box>

              {/* Botón */}
              <Box display="flex" justifyContent="flex-end">
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={() => onAttend(VIEW_TYPES.DETAIL_QUOTE, lastQuote?.id)}
                >
                  {t("reportFolio.detail.general.seeDetailSolution")}
                </Button>
              </Box>
            </Box>
          ) : isRejected ? (
            <Box display="flex" justifyContent="end" gap={3} alignContent={"center"}>
              <ActionDrawer
                title="EVIDENCIAS"
                body={<>
                  <Box sx={styles.mainContainer}>
                    <Box sx={styles.bodyContainer}>
                      <EvidenceDetail
                        existEvidences={existEvidences}
                        evidences={{
                          image: evidences?.images,
                          comment: evidences?.comments,
                          documents: evidences?.documents,
                          video: evidences?.video,
                          sign: evidences?.sign
                        }}
                      />
                    </Box>
                    <Box>
                      <Button variant='text_primary_small' onClick={downloadEvidences} disabled={isDownloading}>{t('schedule.buttons.downloadEvidence')}</Button>
                    </Box>
                  </Box>
                </>}
              >
                {
                  ({ openDrawer }) =>
                    <Tooltip title={t("ToolTips.seeEvidences")}>
                      <IconButton
                        onClick={() => { openDrawer() }}
                        sx={styles.clip}
                        disabled={!existEvidences}
                      >
                        {icons("clip")}
                      </IconButton>
                    </Tooltip>
                }
              </ActionDrawer>

              <Button variant="outlined" color="primary" onClick={() => onAttend(VIEW_TYPES.DETAIL_QUOTE, lastQuote?.id)}>
                {t("reportFolio.detail.general.seeDetailSolution")}
              </Button>
            </Box>
          ) : <></>
        }

        {left?.type === "preventive" && lastQuote.assingQuestionnaire && (
          <>
            <Box sx={{ my: 2 }}>
              <Divider />
            </Box>
            <Box >
              <Questionnary data={left} historial={lastQuote} />
            </Box>
          </>
        )}


      </CustomPaper >

      <SnackSimple
        open={downloadSnack.open}
        close={() => setDownloadSnack({ open: false, message: "" })}
        message={downloadSnack.message}
        type={Types.INFO}
      />
    </>
  );
};
